import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';

import ShipperOrderTableGroupTitle from 'modules/shipper-order/Table/ShipperOrderTableGroupTitle';
import ShipperOrderTableHeader from 'modules/shipper-order/Table/ShipperOrderTableHeader';
import ShipperOrderTable from 'modules/shipper-order/Table/ShipperOrderTable';

import { StyledLoading } from './styled';

const LoadComponent = () => <StyledLoading />;

const ShipperOrderTableGroup = ({ className, hasMore, onRowClick, group, onLoadMore }) => {
  return (
    <>
      <InfiniteScroll
        pageStart={0}
        loadMore={onLoadMore}
        hasMore={hasMore}
        loader={<LoadComponent key={0} />}
        useWindow={false}
        className={className}
      >
        {Object.keys(group).map((groupKey) => (
          <Fragment key={groupKey}>
            <ShipperOrderTableGroupTitle value={groupKey} />
            <ShipperOrderTableHeader />
            <ShipperOrderTable ids={group[groupKey]} onRowClick={onRowClick} />
          </Fragment>
        ))}
      </InfiniteScroll>
    </>
  );
};

ShipperOrderTableGroup.propTypes = {
  group: PropTypes.shape({}),
  onLoadMore: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
  className: PropTypes.string,
};

ShipperOrderTableGroup.defaultProps = {
  group: {},
};

export default ShipperOrderTableGroup;
